module.exports = __webpack_public_path__ + "static/media/group.77ffb4dc.svg";